import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/storybook-color.vue
var o = {
	name: "DtIconStorybookColor",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--storybook-color"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Storybook Color",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M4.618 20.43 4.001 3.92a1.004 1.004 0 0 1 .939-1.04l13.995-.878A1.003 1.003 0 0 1 20 3.006v17.989a1.004 1.004 0 0 1-1.047 1.004l-13.378-.603a1.004 1.004 0 0 1-.957-.967Z",
		fill: "#FF4785"
	}, null, -1), r("path", {
		d: "m15.855 4.427.098-2.277L17.915 2 18 4.348a.15.15 0 0 1-.147.153.156.156 0 0 1-.1-.031l-.757-.579-.896.66a.156.156 0 0 1-.214-.029.145.145 0 0 1-.03-.095ZM13.346 9.44c0 .386 2.681.201 3.041-.07 0-2.63-1.454-4.012-4.118-4.012-2.664 0-4.156 1.404-4.156 3.509 0 3.666 5.1 3.736 5.1 5.736 0 .561-.283.895-.906.895-.812 0-1.133-.403-1.096-1.771 0-.297-3.098-.39-3.192 0C7.779 17.044 9.908 18 12.345 18c2.361 0 4.213-1.221 4.213-3.431 0-3.93-5.177-3.824-5.177-5.772 0-.789.605-.894.964-.894.378 0 1.058.064 1.001 1.538Z",
		fill: "#fff"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=storybook-color.js.map